import React from "react";
import Hades from "../../Assets/img/HadesV2.m4v";
import thor from "../../Assets/img/ThorV.m4v";
import anubis from "../../Assets/img/Anubis.m4v";
import fly from "../../Assets/img/fly.mp4";
import line from "../../Assets/img/line.webp";
import ReactPlayer from "react-player";
import fire from "../../Assets/img/fire.webp";
import back from "../../Assets/img/back.webp";
import banner2 from "../../Assets/img/banner2.webp";
import banner3 from "../../Assets/img/banner3.webp";
import banner4 from "../../Assets/img/banner4.webp";
import arrow from "../../Assets/img/arrow.webp";
import secondban from "../../Assets/img/secondban.webp";
import secban from "../../Assets/img/secban.webp";
import newline from "../../Assets/img/newline.webp";
import line2 from "../../Assets/img/line2.webp";
import blueline from "../../Assets/img/blueline.webp";
import thirban from "../../Assets/img/thirban.webp";
import facedog from "../../Assets/img/facedog.webp";
import lava from "../../Assets/img/lava.webp";
import pink from "../../Assets/img/pink.webp";
import dragon from "../../Assets/img/dragon.webp";
import dogback from "../../Assets/img/dogback.webp";
import polkta from "../../Assets/img/polkta.webp";
import youtube from "../../Assets/img/youtube.webp";
import twitter from "../../Assets/img/twitter.webp";
import man from "../../Assets/img/man.webp";
import { Link } from "react-router-dom";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

const Home = () => {
  return (
    <>
      <Header />
      {/* Banner section  */}
      <section className="Banner-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6  for-back-pic"></div>

            <div className="col-md-6">
              <div className="some-new-vide">
                <div className="video-all">
                  <ReactPlayer
                    url={Hades}
                    playing
                    loop
                    muted
                    width="100%"
                    height="100%"
                  />

                  <div className="arrow-img">
                    <Link to="/">
                      <img src={arrow}></img>
                    </Link>
                  </div>

                  <div className="mints-sold">
                    <div className="mint">
                      <h5>MINTS</h5>
                      <h3>45k</h3>
                    </div>
                    <div className="mint">
                      <h5>SOLD</h5>
                      <h3>45k</h3>
                    </div>
                  </div>
                </div>
                <div className="line-img">
                  <img src={line}></img>
                </div>
              </div>
            </div>
          </div>
          <div className="for-background">
            <img src={banner3}></img>
            <div className="all-dv">
              <div className="dv-text">
                <h2>
                  <span>PLAY, SHARE, COLLECT, </span>
                </h2>
                <h2>
                  AND TRADE WITHOUT <br></br> CENTRAL CONTROL
                </h2>
                <p>
                  A distinct platform that provides a decentralized and
                  immersive environment where you can join the
                  pantheon of Gods at your own will.
                </p>
                <div className="banner-btn-img">
                  <Link to="/">EXPLORE NOW</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="seprator top"></div>
        <div className="seprator bottom"></div>
      </section>
      {/* End of Banner section  */}
      {/* Line section  */}
      {/* <section className="line-sec">
        <img className="for-move1" src={newline}></img>
        <img className="for-move2" src={newline}></img>
      </section> */}
      {/* End of Line section  */}

      {/* Second Section  */}
      <section className="second-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6  for-back-pic">
              <div className="some-new-vide">
                <div className="video-all for-sec-things">
                  <ReactPlayer
                    url={thor}
                    playing
                    loop
                    muted
                    width="100%"
                    height="100%"
                  />
                </div>
                <div className="line-img blueline">
                  <img src={blueline}></img>
                </div>
              </div>
            </div>

            <div className="col-md-6"></div>
          </div>
          <div className="for-background">
            <img src={secban}></img>
            <div className="all-second-dv">
              <div className="dv-text">
                <h2>
                  <span>LET'S GET INSIDE THE MOST </span>
                </h2>
                <h2>
                  EXCITING PLAY-TO-EARN <br></br> HISTORICAL EXPEDITION
                </h2>
                <p className="for-responsive-mobile">
                  Mighty Wings is more than just a play-to-win game; it's a way
                 that changes the history of the gaming experience.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="seprator top"></div>
        <div className="seprator bottom"></div>
      </section>
      {/* End of Second section  */}

      {/* third Banner section  */}
      <section className="Banner-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6  for-back-pic">
              <div className="all-thirdv">
                <div className="dv-text">
                  <h2>
                    <span>BE THE COLLECTOR </span>
                  </h2>
                  <h2>
                    OF SUPER RARE <br></br>DIGITAL ARTWORKS
                  </h2>
                  <p className="for-responsive-mobile">
                    Whether you aspire to be a trader, an entrepreneur, a
                     content creator, or more, you will find something
                    of value to boost  your profits 10X right here.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="some-new-vide">
                <div className="video-all third-video">
                  <ReactPlayer
                    url={anubis}
                    playing
                    loop
                    muted
                    width="100%"
                    height="100%"
                  />
                </div>
                <div className="line-img">
                  <img src={line}></img>
                </div>
              </div>
            </div>
          </div>
          <div className="for-background">
            <img src={thirban}></img>
          </div>
        </div>
        <div className="for-movement">
          <div className="seprator top for-move"></div>
          <div className="seprator bottom for-move"></div>
          <div className="seprator top for-height"></div>
          <div className="seprator bottom for-height"></div>
          <div className="seprator top for-no-height"></div>
          <div className="seprator bottom for-no-height"></div>
          <div className="seprator top for-no-height"></div>
          <div className="seprator bottom for-no-height"></div>
          <div className="seprator top for-no-height"></div>
          <div className="seprator bottom for-no-height"></div>
          <div className="seprator top for-move for-no-height"></div>
          <div className="seprator top for-no-height"></div>
          <div className="seprator bottom for-no-height"></div>
          <div className="seprator bottom for-move for-no-height"></div>
        </div>
      </section>
      {/* <End of third Ban section  */}
      <section className="firesss-sec">
        <div className="background-video">
          <ReactPlayer
            className="react-player no-height"
            url={fly}
            playing
            loop
            muted
            width="100vw"
          />
        </div>
      </section>

      {/* About Section  */}
      <section className="about-sec">
        {/* <div className="background-video">
          <ReactPlayer
            className="react-player"
            url={fly}
            playing
            loop
            muted
            width="100vw"
            height="100vh"
          />
        </div> */}
        <div className="container-fluid">
          <div className="about-head">
            <h2>
              ABOUT<span>NFTS</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="aboutbox">
                <div className="about-img">
                  <img className="img-fluid" src={lava}></img>
                </div>
                <div className="about-some-text">
                  <h5>10H:20M:30M</h5>
                </div>
                <div className="some-flex">
                  <div className="about-img-text">
                    <img src={man}></img>
                    <div className="heading-for-flex">
                      <h3>NFTS PAGE</h3>
                      <p>Frank Jerry</p>
                    </div>
                  </div>
                  <div className="current">
                    <p>CURRENT BID</p>
                    <h5>1.50 ETH</h5>
                  </div>
                </div>
                <div className="some-text">
                  <h4> 6,240 USD</h4>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="aboutbox">
                <div className="about-img">
                  <img className="img-fluid" src={facedog}></img>
                </div>
                <div className="about-some-text">
                  <h5>10H:20M:30M</h5>
                </div>
                <div className="some-flex">
                  <div className="about-img-text">
                    <img src={man}></img>
                    <div className="heading-for-flex">
                      <h3>NFTS PAGE</h3>
                      <p>Frank Jerry</p>
                    </div>
                  </div>

                  <div className="current">
                    <p>CURRENT BID</p>
                    <h5>1.50 ETH</h5>
                  </div>
                </div>
                <div className="some-text">
                  <h4> 6,240 USD</h4>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="aboutbox">
                <div className="about-img">
                  <img className="img-fluid" src={pink}></img>
                </div>
                <div className="about-some-text">
                  <h5>10H:20M:30M</h5>
                </div>
                <div className="some-flex">
                  <div className="about-img-text">
                    <img src={man}></img>
                    <div className="heading-for-flex">
                      <h3>NFTS PAGE</h3>
                      <p>Frank Jerry</p>
                    </div>
                  </div>
                  <div className="current">
                    <p>CURRENT BID</p>
                    <h5>1.50 ETH</h5>
                  </div>
                </div>
                <div className="some-text">
                  <h4> 6,240 USD</h4>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="aboutbox">
                <div className="about-img">
                  <img className="img-fluid" src={dragon}></img>
                </div>
                <div className="about-some-text">
                  <h5>10H:20M:30M</h5>
                </div>
                <div className="some-flex">
                  <div className="about-img-text">
                    <img src={man}></img>
                    <div className="heading-for-flex">
                      <h3>NFTS PAGE</h3>
                      <p>Frank Jerry</p>
                    </div>
                  </div>
                  <div className="current">
                    <p>CURRENT BID</p>
                    <h5>1.50 ETH</h5>
                  </div>
                </div>
                <div className="some-text">
                  <h4> 6,240 USD</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of About section  */}

      {/* Road map section  */}
      <section className="Road-map-sec">
        <div className="container-fluid">
          <div className="about-head road-map-head">
            <h2>
              ROAD<span>MAP</span>
            </h2>
          </div>
          <div className="row for-upper-padding">
            <div className="col-md-4 col-sm-4">
              <div className="all-road-map">
                <div className="all-roadmap-text">
                  <h5>NFT </h5>
                  <h3>
                    Launching in <span>August 2022 </span>{" "}
                  </h3>
                  <p className="mb-0">
                    About 5,555 NFTs are set to be released in the first batch,
                    divided into 4 tiers:
                  </p>
                  <p>
                    <ul>
                      <li>
                        <b>Special Edition:</b> 5 NFTs
                      </li>
                      <li>
                        <b>God-Tier:</b> Premium and distinct 150 Animated NFTs
                      </li>
                      <li>
                        <b>Mid-Tier:</b> 1655 animated character NFTs
                      </li>
                      <li>
                        <b>Basic-Tier:</b> 3745 Floating/hovering NFTs
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-4 for-hidding"></div>

            <div className="col-md-4 col-sm-4">
              <div className="all-road-map road-float">
                <div className="all-roadmap-text">
                  <h5>METAVERSE </h5>
                  <h3>
                    Launching in <span>June 2023</span>{" "}
                  </h3>
                  <p className="mb-0">
                    It's a unique kind of digital verse aiming to revolutionize
                    the WEB3 experience. This virtual world is divided into two
                    aspects:
                  </p>
                  <p>
                    <ul>
                      <li>
                        <b>Museum Creation </b>
                      </li>
                      <li>
                        <b>Buy & Sell Real Estate</b>
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 col-sm-4">
              <div className="all-road-map">
                <div className="all-roadmap-text">
                  <h5>MIGHTY WINGS GAME </h5>
                  <h3>
                    Release Date <span>August 2023</span>{" "}
                  </h3>
                  {/* <p className="mb-0">
                    Full Game launch of this state-of-the-art multiplayer game,
                    <br></br> built on the fastest and the best gaming engine in
                    <br></br>the world –Unreal Engine 5.
                  </p>
                  <p className="mb-0">
                    The game comes with a detailed campaign mode for each of
                    <br></br> our characters in an open-world environment
                    <br></br>where the players will solve different quests.
                  </p>
                  <p>
                    This game would be available on PC, consoles, and
                    smartphones.{" "}
                  </p> */}
                  <p>
                    <ul>
                      <li>
                        Full Game launch of this state-of-the-art multiplayer
                        game, built on the fastest and the best gaming engine in
                        the world –Unreal Engine 5.{" "}
                      </li>
                      <li>
                        The game comes with a detailed campaign mode for each of
                        our characters in an open-world environment where the
                        players will solve different quests.
                      </li>
                      <li>
                        This game would be available on PC, consoles, and
                        smartphones.
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-4 for-hiding"> </div>
            <div className="col-md-4 col-sm-4">
              <div className="all-road-map road-float">
                <div className="all-roadmap-text">
                  <h5>CRYPTOCURRENCY </h5>
                  <h3>
                    Release Date <span>August 2023 </span>{" "}
                  </h3>
                  {/* <p>
                    Introducing the very first Governance token that allows
                    <br></br>holders to participate in governance and make
                    <br></br> important decisions of the platform using DAO
                    structure.<br></br>Using this token, the players can buy
                    equipment and<br></br> customize their Avatar characters in
                    Game and Metaverse.
                  </p> */}
                  <p>
                    Introducing the very first Governance token that allows
                    holders to participate in governance and make important
                    decisions of the platform using DAO structure. Using this
                    token, the players can buy equipment and customize their
                    Avatar characters in Game and Metaverse.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of Road map section  */}

      {/* Video map section  */}
      <section className="video-sec">
        <div className="container">
          <div className="about-head">
            <h2>
              FEATURED<span> VIDEO</span>
            </h2>
            <p>
              Curious about our ongoing game and ecosystem development? Catch a
              glimpse of our <br></br> virtual world where you can play,
              collect, share, and govern.
            </p>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="video-featured">
                <div className="video-play">
                  <img className="img-fluid" src={dogback}></img>
                </div>
                <div className="play-btn">
                  <Link to="/">
                    {" "}
                    <i className="fa fa-play" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of video section  */}

      {/* FAq section  */}
      <section className="faq-sec">
        <div className="container">
          <div className="about-head">
            <h2>FAQS</h2>
            <p>Get all your burning questions answered!</p>
          </div>
          <div id="accordion">
            <div className="row">
              <div className="col-lg-6">
                <div className="card">
                  <div className="inner-back">
                    <div className="card-header" id="headingOne">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          <h4>What is Mighty Wings? </h4>
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      className="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        Mighty Wings is a tri-platform –NFT, Game, and
                        Meta-verse –where users have full rights over their NFTs
                        and Metaverse lands without central authority or
                        control. They can play, collect, share, earn, and even
                        govern anything in this Metaverse. Likewise, they can
                        enjoy 100% copyright ownership and can win many rewards
                        through the use of NFT.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="inner-back">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          <h4>What are the benefits of Mighty Wings NFT? </h4>
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseTwo"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        While there are more than 500,000 NFTs, Games,
                        Metaverse, and about 160,000 MAUs, Mighty Wings believes
                        that innovation is important to remain distinct from the
                        rest. Therefore, we have come up with a different route
                        plan that offers something for everyone. Whether you
                        wish to be a trader or an entrepreneur, our
                        PC/Console/Mobile game, Comic books, Animated Series,
                        Meta-verse, cryptocurrency, NFT apparel merchandising,
                        digital frame for our premium NFT holders, card battle
                        game, and child cancer donation will help you push the
                        boundaries and challenge the status quo of the current
                        market.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card">
                  <div className="inner-back">
                    <div className="card-header" id="headingThree">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="true"
                          aria-controls="collapseThree"
                        >
                          <h4>
                            How is Mighty Wings different from the other
                            platforms?
                          </h4>
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                      </h5>
                    </div>

                    <div
                      id="collapseThree"
                      className="collapse show"
                      aria-labelledby="headingThree"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        Mighty Wings is set out to become the largest
                        decentralized prehistoric world of Metaverse that is
                        owned by the community of enthusiasts. Through our
                        platform, the user can explore the medieval era of Gods:
                        Greek Empire, Norse the Vikings, Egyptian the land of
                        Sand, Chinese Dynasty, and Imperial Japan. In addition,
                        our platform guarantees 100% true ownership of assets
                        and items they purchase or earn in the game.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="inner-back">
                    <div className="card-header" id="headingFour">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          <h4>When is the game being launched? </h4>
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseFour"
                      className="collapse"
                      aria-labelledby="headingFour"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        Mighty Wings is set out to be released in August 2023.
                        So far, we have achieved various milestones, including
                        visual assets, game environment development, and initial
                        designing. We will be releasing the game in phases, such
                        as in the first round, we'll release a closed alpha
                        version to early investors. During the second phase of
                        gameplay, as the number of players and community
                        increases, there will be an increase in our rewards and
                        airdrops. The full game will be launched to play along
                        with VR integration by the 3rd phase of 2023. This
                        enables our users to stake rewards before the launch of
                        the game and increase their passive income stream after
                        the launch of the game.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of Faq section  */}

      {/* Join our social icon  */}
      <section className="social-icon-sec ">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="social-head">
                <h5>JOIN OUR SOCIAL MEDIA</h5>
                <ul>
                  <li>
                    <Link to="/">
                      <img src={twitter}></img>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <img src={polkta}></img>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <img src={youtube}></img>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of our social icon  */}

      <Footer />
    </>
  );
};

export default Home;
